import React from 'react';
import PropTypes from 'prop-types';
import * as Styles from './index.styles';

const { StyledOption } = Styles;

export const Option = React.forwardRef(function Option({ onClick, children, ...otherProps }, ref) {
    return (
        <StyledOption ref={ref} onClick={onClick} {...otherProps}>
            {children}
        </StyledOption>
    );
});

Option.propTypes = {
    className: PropTypes.string,
    noHover: PropTypes.bool,
    selected: PropTypes.bool,
    onClick: PropTypes.func,
    children: PropTypes.node.isRequired,
};

Option.defaultProps = {
    className: '',
    noHover: false,
    selected: false,
    onClick: () => null,
};

Option.Styles = Styles;
